export enum AvatarSize {
  XSmall = 'x-small',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'x-large',
}

export enum AvatarColor {
  Black = 0,
  Cyan = 1,
  Salmon = 2,
  Blue = 3,
  Gray = 4,
}

export const avatarColorMap = {
  [AvatarColor.Black]: '#2D3748',
  [AvatarColor.Cyan]: '#4A9B8E',
  [AvatarColor.Salmon]: '#C67A7A',
  [AvatarColor.Blue]: '#6B9BD2',
  [AvatarColor.Gray]: '#718096',
};
